define((require) => {
    "use strict";

    var _               = require("underscore"),
        ContentItemView = require("ui/dashboard/ContentItemView"),
        template        = require("ui/projects/content/ProjectContentItemView.tpl");


    /**
     * Abstract <tt>ContentItemView</tt> subclass for project dashboards.
     *
     * @see ProjectDashboardContentItemView
     * @see ProjectAttachContentItemView
     *
     * @class ProjectContentItemView
     */
    return ContentItemView.extend({

        template: template,

        viewOptions: {
            showExperienceActionsPanel: true,
            showSelectIndicator: false
        },

        templateHelpers: function() {
            // Pass the viewOptions to the template
            return _.extend(this.__super(), this.viewOptions);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/content/ProjectContentItemView.js